/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { Link, CardSupport, ButtonPrimary, ApiError } from '@core/index';
import { appCardStyle, appIconsPath } from '@utils/globalConstant';
import './Feedback.scss';
import Icons from '@core/Utils/Icons/Icons';

export function Feedback({
  children = null,
  icon = '',
  iconName = '',
  headingContent = {},
  copyTextContent = {},
  buttonContent,
  buttonText = '',
  buttonType = '',
  buttonIcon = '',
  buttonClick = () => {},
  linkText,
  linkIcon = '',
  linkStyle = '',
  linkSize = '',
  linkRef = '#',
  showCard,
  replaceTitle = '',
  replaceTitleBy = '',
  apiError = false
}) {
  // State & Refs
  const [visible, setVisible] = useState(false);
  // Functions

  // hooks
  useEffect(() => {
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 300);

    return () => clearTimeout(timeout);
  }, []);
  return (
    <div className="feedback min-dvh-100 w-100">
      {/* No need anymore to make this explicitly read because now the content 
      is already ready completely by setting focus to the page content. */}
      {/* <div
        aria-live="assertive"
        aria-atomic="true"
        style={{
          position: 'absolute',
          overflow: 'hidden',
          clip: 'rect(0 0 0 0)',
          height: 1,
          width: 1,
          margin: -1,
          padding: 0,
          border: 0,
        }}
      >
        {visible && (
          <>
            <span>{headingContent?.content?.replace(replaceTitle, replaceTitleBy)}</span>
            <span>{copyTextContent?.content}</span>
            <div role='button'>
              {buttonContent?.content}
            </div>
          </>
        )}
      </div> */}
      <div className="feedback-details-container w-100 position-relative bg-transparent  min-dvh-100 d-flex justify-content-center align-items-center">
        <AppPageContentWrapper>
          <div className="content-main-container w-100 h-100 d-flex align-items-center flex-column ">
            {icon ? (
              <div className="icon-container">
                <Icons name={icon} alt={iconName}  colorType='dark' />
              </div>
            ) : (
              ''
            )}
            {headingContent.content !== '' &&
              headingContent.content !== undefined &&
              (headingContent.isHtml ? (
                <div className="title-container text-center">
                  <div className="space-40" />
                  <h1
                    className="ek-h1 m-0 text-primary"
                    dangerouslySetInnerHTML={{ __html: headingContent.content.replace(replaceTitle, replaceTitleBy) }}
                  />
                  <div className="space-40" />
                </div>
              ) : (
                <div className="title-container text-center">
                  <div className="space-40" />
                  <h1 className="ek-h1 m-0 text-primary">{headingContent.content.replace(replaceTitle, replaceTitleBy)}</h1>
                  <div className="space-40" />
                </div>
              ))}
            {copyTextContent.content !== '' &&
              copyTextContent.content !== undefined &&
              (copyTextContent.isHtml ? (
                <div className="sub-title-container text-center pb-40">
                  <p
                    className="ek-copy-16-regular text-primary"
                    dangerouslySetInnerHTML={{ __html: copyTextContent?.content }}
                  />
                </div>
              ) : (
                <div className="sub-title-container text-center pb-40">
                  <p className="ek-copy-16-regular text-primary">{copyTextContent?.content}</p>
                </div>
              ))}

            {
              apiError && 
              <div className="pb-40 w-100">
                <ApiError />
              </div>
            }

            <ButtonPrimary
              iconRight={buttonIcon}
              buttonType={buttonType}
              buttonContent={buttonContent}
              label={buttonText}
              onClick={() => buttonClick()}
            />

            {linkText && linkRef ? (
              <>
                <div className="space-24" />
                <Link
                  label={linkText}
                  iconRight={linkIcon}
                  linkStyle={linkStyle}
                  linkSize={linkSize}
                  linkRef={linkRef}
                />
                <div className="space-24" />
              </>
            ) : (
              ''
            )}
            <div className="space-40" />
            {showCard && <div className="w-100"><CardSupport /></div>}
          </div>
        </AppPageContentWrapper>
      </div>
    </div>
  );
}

Feedback.propTypes = {
  children: PropTypes.node,
  icon: PropTypes.string,
  iconName: PropTypes.string,
  title: PropTypes.string,
  subText: PropTypes.string,
  buttonText: PropTypes.string,
  buttonType: PropTypes.string,
  buttonIcon: PropTypes.string,
  linkText: PropTypes.string,
  linkIcon: PropTypes.string,
  linkStyle: PropTypes.string,
  linkSize: PropTypes.string,
  linkRef: PropTypes.string
};

export default Feedback;
